module.exports = __webpack_public_path__ + "img/4.13250682.jpg";